import { Wrapper } from "src/types";
import HistoryProvider from "./historyProvider";
import QueryProvider from "./queryProvider";
import AuthenticationProvider from "./authenticationProvider";
import { Toaster } from "src/shadcn/ui/sonner";

const AppProvider: Wrapper = ({ children }) => {
  return (
    <HistoryProvider>
      <QueryProvider>
        <AuthenticationProvider>
          {children}
          <Toaster closeButton={true} swipeDirections={["left", "right"]} />
        </AuthenticationProvider>
      </QueryProvider>
    </HistoryProvider>
  );
};

export default AppProvider;
